import momentTimezone from 'moment-timezone';

const appMoment = momentTimezone;

export function setAppTimezone() {
  // appMoment.tz.setDefault(timezone);
}

export const moment = appMoment;